var plugin_rtlignore_default = {
  "alignLeft": "GgARi",
  "textWrapNowrap": "scQys",
  "alignRight": "o7gMD",
  "alignCenter": "sD-MB",
  "sizeFullWidth": "rL-ST",
  "renderedInTable": "TSdcQ",
  "sizeOriginal": "-s-up",
  "sizeContent": "Cr--N",
  "sizeSmall": "_6eeS7",
  "sizeSmallCenter": "b4dbM",
  "flex": "mIlwh",
  "atomic": "C-G54",
  "embed": "jgyY2",
  "horizontalScrollbar": "PbvGh",
  "pluginContainerMobile": "SpEBj"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
